module.exports = __webpack_public_path__ + "static/media/theMofG34.9a24bf67.png";